import { NavLink } from "react-router";

import { cn } from "@/lib/utils";

import { useNavAccess } from "../use-nav-access";

import type { NavItem } from "../nav-config";

/** One titled list of links inside the "Lainnya" sheet. */
export function BottomNavGroup({
  title,
  items,
  onNavigate,
}: {
  title: string;
  items: NavItem[];
  onNavigate: () => void;
}) {
  const { isAllowed } = useNavAccess();
  const visible = items.filter(isAllowed);
  if (visible.length === 0) return null;
  return (
    <div>
      <p className="mb-1.5 px-1 text-xs font-medium text-muted-foreground">
        {title}
      </p>
      <div className="grid gap-1">
        {visible.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={onNavigate}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 rounded-md px-3 py-2.5 text-sm",
                  isActive
                    ? "bg-primary text-primary-foreground"
                    : "hover:bg-muted",
                )
              }
            >
              <Icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          );
        })}
      </div>
    </div>
  );
}
